export default __webpack_public_path__ + "assets/dankort-aaea77a047aea79cff844ec89473a5d0.svg";